export const RDY_FOR_VALIDATION = "Import In Progress"; // state#1
export const VALIDATION_IN_PROGRESS = "Import In Progress"; //after  submitted to PDF
export const VALIDATION_COMPLETE = "Import In Progress";
export const VALIDATION_FAILED = "Import Failed";  // PDF returned invalid Json file. 
export const VALIDATION_ERROR = "Import Failed";  //PDF validated  Errors returned. 
export const RDY_FOR_IMPORT = "Import In Progress";//PDF  validated, and no errors and handover to PCX
export const IMPORT_FAILURE = "Import Failed";
export const IMPORT_SUCCESS = "Import Successful";
export const IMPORT_ERROR = "Import Failed";
export const IMPORT_RUNTIME_ERROR="Import Failed";
export const IMPORT_INVALID_FILE_ERROR="Import Failed";
export const IMPORT_FAIL_EXCEED_MAX_LIMIT="Import Failed";
export const IMPORT_BAD_REQUEST_ERROR="Import Failed";
export const IMPORT_IN_PROGRESS = "Import In Progress";
export const IMPORT_FAILED = "Import Failed";
export const IMPORT_SCHEMA_ERROR="Import Failed";
export const IMPORT_ACCESS_ERROR = "Import Failed";
export const IMPORT_SUCCESS_WARNING = "Import Successful";
export const IMPORT_SUCCESS_PARTIAL = "Import Partially Successful";
export const IMPORT_DATA_ERROR = "Import Failed";
export const FILE_TYPE_ERROR = "File should be xlsx";
export const FILE_SIZE_ERROR = "File size exceeded";
export const DUPLICATE_FILE_ERROR= "Duplicate file name";
export const READY_FOR_IMPORT_LABEL="Ready for Import";
export const INVALID_SHEET_NAME_LABEL="Invalid Sheet Name";
export const INVALID_NUMBER_OF_SHEETS_LABEL="Only one Sheet allowed per file: Either one of FOBC, EBLB, CostSheetTrigger or QuoteDeferral";
export const SUCCESS="Success";
export const ALL_LOADER_TYPES="ALL";
export const FOBC_LOADER_TYPE="FOBC";
export const EB_LB_LOADER_TYPE="EBLB";
export const CostSheetTrigger_LOADER_TYPE="CostSheetTrigger";
export const QUOTE_DEFERRAL_LOADER_TYPE="QuoteDeferral";
export const EQ_FOB_LOADER_TYPE="EQFOB";
export const FOBC_SHEET_NAME="FOBC";
export const EB_LB_SHEET_NAME="EBLB";
export const CostSheetTrigger_SHEET_NAME="CostSheetTrigger";
export const QUOTE_DEFERRAL_SHEET_NAME="QuoteDeferral";
export const EQ_FOB_SHEET_NAME="EQFOB";

export const quotemanagement = {
    contentType : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    uploadFilesMaxLimit : "10"
    
};

export const FW_FOB_EBLB_ALLOWED_GROUP=['App.PCX-DLA.QuoteMgmt.CostingDOT','App.PCX-DLA.QuoteMgmt.Preprod']
export const EQ_FOB_ALLOWED_GROUP=['App.PCX-DLA-EQFOB.PreProd','App.PCX-DLA-EQFOB.CostsheetUpdate']
